module.exports = __webpack_public_path__ + "img/video.5047d207.png";